import React from 'react';

import PregnancyParentingIcon from 'assets/icons/kb360/pregnancy-parenting.svg?react';
import WellnessIcon from 'assets/icons/kb360/wellness.svg?react';

export const SERVICE_TYPE_ICONS = {
  'Pregnancy and Beyond': PregnancyParentingIcon,
  Wellness: WellnessIcon
};

export const SERVICE_TYPES = Object.keys(SERVICE_TYPE_ICONS) as Array<KB360ServiceType>;

export type KB360ServiceType = keyof typeof SERVICE_TYPE_ICONS;

interface ServiceTypeIconProps {
  serviceType: KB360ServiceType;
  className?: string;
}

export const ServiceTypeIcon = ({ serviceType, className }: ServiceTypeIconProps) => {
  const Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>> =
    SERVICE_TYPE_ICONS[serviceType];

  return Icon ? <Icon className={className} /> : <>{serviceType}</>;
};
